import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const tiles = [
  {
    to: '/admin/dashboard',
    title: 'לוח בקרה',
    text: 'מעקב אחר התקדמות המילוי לפי מחלקה ועובד/ת, עריכת המסמכים והורדת קובצי Word ו-Excel.',
    icon: (
      <svg viewBox="0 0 48 48" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="6" y="8" width="36" height="32" rx="3" /><path d="M14 30v-8M24 30V16M34 30v-4" />
      </svg>
    ),
  },
  {
    to: '/admin/users',
    title: 'עובדים',
    text: 'הוספה ועדכון של עובדים, מחלקות ומנהלים ישירים, וייבוא רשימות מ-Excel.',
    icon: (
      <svg viewBox="0 0 48 48" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="16" r="7" /><path d="M4 40c0-8 6-13 14-13s14 5 14 13" /><circle cx="34" cy="18" r="5" /><path d="M34 27c6 0 10 4 10 11" />
      </svg>
    ),
  },
  {
    to: '/admin/cycles',
    title: 'תהליכים',
    text: 'פתיחת מחזור משוב, בניית השאלונים לכל שכבה, תצוגה מקדימה והפעלה.',
    icon: (
      <svg viewBox="0 0 48 48" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M40 24a16 16 0 1 1-4.7-11.3" /><path d="M40 8v9h-9" /><path d="M18 24l4 4 8-8" />
      </svg>
    ),
  },
];

/** Admin landing page: brand hero (the Jerusalem buildings from young-jerusalem.org) + three big entry tiles. */
export default function AdminHome() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="home">
      <section className="home-hero" aria-label="רשות הצעירים של ירושלים">
        <img src="/img/cloud.svg" alt="" className="home-cloud home-cloud-a" />
        <img src="/img/cloud.svg" alt="" className="home-cloud home-cloud-b" />
        <div className="home-hero-text">
          <h1>משוב והתפתחות</h1>
          <p>רשות הצעירים של ירושלים</p>
          {user && <span className="home-hello">שלום {user.full_name}, לאן ממשיכים?</span>}
        </div>
        <img src="/img/hero-right.png" alt="" className="home-buildings home-buildings-right" />
        <img src="/img/hero-left.png" alt="" className="home-buildings home-buildings-left" />
      </section>

      <section className="home-tiles">
        {tiles.map(t => (
          <button key={t.to} className="home-tile" onClick={() => navigate(t.to)}>
            <span className="home-tile-icon">{t.icon}</span>
            <span className="home-tile-title">{t.title}</span>
            <span className="home-tile-text">{t.text}</span>
            <span className="home-tile-cta">כניסה ←</span>
          </button>
        ))}
      </section>
    </div>
  );
}
